import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state?.notification || initialState;

export const selectNotification = createSelector([selectSlice], state => state);
